import $ from 'zepto';
import { onDocumentReady } from '../main';

const $body = $(document.body);

const wrapperLayoutSelector = '.xppvx_layout-content';
const elementHeightSelector = '.js-xppvx_display-height-60vh';
const layoutMinHeight = 60;
let windowResizeTimeout;

function getLayoutContentHeight(vh) {
  return Math.round(window.innerHeight / (100 / vh));
}

function fixLayoutHeight(element) {
  if ($(element).height() < getLayoutContentHeight(layoutMinHeight)) {
    $(elementHeightSelector).css('min-height', '60vh');
  } else {
    $(elementHeightSelector).css('min-height', 'auto');
  }
}

export function layoutHeight($context = $body) {
  const wrapperElement = $context.find(wrapperLayoutSelector);
  if (wrapperElement.length) {
    fixLayoutHeight(wrapperElement);
    $(window).bind('resize', () => {
      // use a timeout to help throttle too many event being fired
      // when window is being re-sized.
      clearTimeout(windowResizeTimeout);
      windowResizeTimeout = setTimeout(() => {
        fixLayoutHeight(wrapperElement);
      }, 500);
    });
  }
}

onDocumentReady('layoutHeight', () => {
  layoutHeight($body);
});
export default {
  layoutHeight,
};
